// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-list {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 0px 15px 5px 15px;
}

.file-footer {
  display: flex;
  margin: 0px 15px 0px 0px;
  padding: 0px;
}

.card {
  border-radius: 8px !important;
}

.file-card {
  flex: 0 0 auto;
  margin: 0px 10px 0px 0px;
  background-color: var(--app-white);
  width: 3cm;
  height: 3cm;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-card-content {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.file-description {
  color: var(--app-white);
  background-color: var(--app-ink-alpha-600);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  width: 100%;
  height: 20%;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 3px;
}

/* Ícone de ação — posição topo-centro (igual .icon-viewer do file-upload-selector) */
.icon-viewer {
  font-size: var(--app-font-size-22px);
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}

/* Imagem proporcional dentro do carousel modal */
.img-proportional {
  width: auto;
  max-width: 100%;
  max-height: 92dvh !important;
  margin: 0 auto;
  display: block;
}

/* ================================================
   CLASSES EXCLUSIVAS DO CAROUSEL
   ================================================ */

.carousel-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  background-color: var(--app-black);
  border-radius: 8px;
  min-height: 200px;
}

.carousel-track {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
}

.carousel-slide {
  flex-shrink: 0;
  scroll-snap-align: start;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: var(--app-black);
  min-height: 200px;
}

/* Botões de navegação (prev / next) */
.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: var(--app-white-alpha-150);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.2s ease;
}

.carousel-btn:hover:not(:disabled) {
  background-color: var(--app-white-alpha-350);
}

.carousel-btn:disabled {
  opacity: 0.25;
  cursor: default;
}

.carousel-btn i {
  font-size: var(--app-font-size-24px);
}

.carousel-btn-prev {
  left: 8px;
}

.carousel-btn-next {
  right: 8px;
}

/* Dots indicadores */
.carousel-indicators-sgr {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  z-index: 10;
}

.indicator-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--app-white-alpha-400);
  cursor: pointer;
  transition: background-color 0.25s ease, transform 0.2s ease;
}

.indicator-dot.active {
  transform: scale(1.3);
  background-color: var(--app-primary);
}

/* Legenda sobreposta na base da imagem */
.carousel-caption-sgr {
  position: absolute;
  bottom: 30px; /* acima dos dots */
  left: 0;
  right: 0;
  background-color: var(--app-ink-alpha-500);
  color: var(--app-white);
  text-align: center;
  padding: 4px 8px;
}

/* Contador numérico — canto superior direito */
.carousel-counter {
  position: absolute;
  top: 8px;
  right: 10px;
  background-color: var(--app-ink-alpha-450);
  color: var(--app-white);
  font-size: var(--app-font-size-12px);
  padding: 2px 8px;
  border-radius: 10px;
  z-index: 10;
}

.file-card { cursor: pointer; }
.icon-viewer, .carousel-btn { color: var(--app-primary); }
.carousel-track::-webkit-scrollbar { display: none; }
@media (prefers-reduced-motion: reduce) { .carousel-track { scroll-behavior: auto; } }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/file-viewer/file-viewer.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,kCAAkC;EAClC,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,8BAA8B;EAC9B,+BAA+B;EAC/B,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,qFAAqF;AACrF;EACE,oCAAoC;EACpC,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,cAAc;AAChB;;AAEA;;qDAEqD;;AAErD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,YAAY,EAAE,mBAAmB;EACjC,OAAO;EACP,QAAQ;EACR,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,0CAA0C;EAC1C,uBAAuB;EACvB,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA,aAAa,eAAe,EAAE;AAC9B,8BAA8B,yBAAyB,EAAE;AACzD,qCAAqC,aAAa,EAAE;AACpD,0CAA0C,kBAAkB,qBAAqB,EAAE,EAAE","sourcesContent":[".file-list {\n  display: flex;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 0px 15px 5px 15px;\n}\n\n.file-footer {\n  display: flex;\n  margin: 0px 15px 0px 0px;\n  padding: 0px;\n}\n\n.card {\n  border-radius: 8px !important;\n}\n\n.file-card {\n  flex: 0 0 auto;\n  margin: 0px 10px 0px 0px;\n  background-color: var(--app-white);\n  width: 3cm;\n  height: 3cm;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.file-card-content {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.file-description {\n  color: var(--app-white);\n  background-color: var(--app-ink-alpha-600);\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  width: 100%;\n  height: 20%;\n  position: absolute;\n  bottom: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-left: 3px;\n}\n\n/* Ícone de ação — posição topo-centro (igual .icon-viewer do file-upload-selector) */\n.icon-viewer {\n  font-size: var(--app-font-size-22px);\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: pointer;\n}\n\n/* Imagem proporcional dentro do carousel modal */\n.img-proportional {\n  width: auto;\n  max-width: 100%;\n  max-height: 92dvh !important;\n  margin: 0 auto;\n  display: block;\n}\n\n/* ================================================\n   CLASSES EXCLUSIVAS DO CAROUSEL\n   ================================================ */\n\n.carousel-wrapper {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  background-color: var(--app-black);\n  border-radius: 8px;\n  min-height: 200px;\n}\n\n.carousel-track {\n  display: flex;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  scrollbar-width: none;\n}\n\n.carousel-slide {\n  flex-shrink: 0;\n  scroll-snap-align: start;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background-color: var(--app-black);\n  min-height: 200px;\n}\n\n/* Botões de navegação (prev / next) */\n.carousel-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: var(--app-white-alpha-150);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10;\n  transition: background-color 0.2s ease;\n}\n\n.carousel-btn:hover:not(:disabled) {\n  background-color: var(--app-white-alpha-350);\n}\n\n.carousel-btn:disabled {\n  opacity: 0.25;\n  cursor: default;\n}\n\n.carousel-btn i {\n  font-size: var(--app-font-size-24px);\n}\n\n.carousel-btn-prev {\n  left: 8px;\n}\n\n.carousel-btn-next {\n  right: 8px;\n}\n\n/* Dots indicadores */\n.carousel-indicators-sgr {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 6px;\n  z-index: 10;\n}\n\n.indicator-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--app-white-alpha-400);\n  cursor: pointer;\n  transition: background-color 0.25s ease, transform 0.2s ease;\n}\n\n.indicator-dot.active {\n  transform: scale(1.3);\n  background-color: var(--app-primary);\n}\n\n/* Legenda sobreposta na base da imagem */\n.carousel-caption-sgr {\n  position: absolute;\n  bottom: 30px; /* acima dos dots */\n  left: 0;\n  right: 0;\n  background-color: var(--app-ink-alpha-500);\n  color: var(--app-white);\n  text-align: center;\n  padding: 4px 8px;\n}\n\n/* Contador numérico — canto superior direito */\n.carousel-counter {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  background-color: var(--app-ink-alpha-450);\n  color: var(--app-white);\n  font-size: var(--app-font-size-12px);\n  padding: 2px 8px;\n  border-radius: 10px;\n  z-index: 10;\n}\n\n.file-card { cursor: pointer; }\n.icon-viewer, .carousel-btn { color: var(--app-primary); }\n.carousel-track::-webkit-scrollbar { display: none; }\n@media (prefers-reduced-motion: reduce) { .carousel-track { scroll-behavior: auto; } }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
